import { render, staticRenderFns } from "./HousePackageElectricity.vue?vue&type=template&id=f55733f2"
import script from "./HousePackageElectricity.vue?vue&type=script&lang=ts"
export * from "./HousePackageElectricity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports